import { RunIdentificationPair } from '@neptune/shared/entity-domain';

export function buildNextSelectionSets(
  currentRunIds: string[],
  currentExperimentNames: string[],
  runIdentificationPairs: RunIdentificationPair[],
) {
  const nextRunIdsSet = new Set(currentRunIds);
  const nextExpNamesSet = new Set(currentExperimentNames);

  for (const pair of runIdentificationPairs) {
    if (pair.experimentName) {
      nextExpNamesSet.add(pair.experimentName);
    } else {
      nextRunIdsSet.add(pair.runId);
    }
  }

  return { nextRunIdsSet, nextExpNamesSet };
}
